// Curb Crew retail pricing config.
// Adjust these once final hardware/postage costing is locked in — every page updates automatically.

export const PRICING = {
  pack_size: 2,                    // codes per pack ("buy 1, get 1 free")
  pack_price: 99,                  // R wholesale pack price
  pack_cards_resold: 2,

  // Retail
  cardholder_price: 99,            // R retail price per Curb Crew

  // Internal cost (admin-only — not shown on public pages)
  hardware_cost_per_card: 15,      // lanyard R13 + printing R2

  // Shipping
  shipping_fee: 110,               // R PostNet-to-PostNet
  free_shipping_threshold: 20,     // codes — order this many or more for free PostNet

  currency_symbol: "R",
};

// Curb Crew's net profit per card sold (gross margin after hardware, ignoring shipping)
export const curbMarginPerCard = () =>
  Math.round(
    (PRICING.pack_price - PRICING.hardware_cost_per_card * PRICING.pack_size) /
      PRICING.pack_size
  );

export const fmtR = (n) => `${PRICING.currency_symbol}${Math.round(n).toLocaleString("en-ZA")}`;
